import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PackagePlan } from '../../../model/PackagePlan';

@Component({
  selector: 'app-package-plan-button',
  standalone: true,
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class PackagePlanButtonComponent {
  @Input() plan: PackagePlan = new PackagePlan('');
  @Output() onButtonClick = new EventEmitter<void>();

  onClickFunction(): void {
    console.log('Button clicked');
    this.onButtonClick.emit();
  }
}
